(() => {
  const product = document.querySelector('#main-product');
  const stringsNode = document.querySelector('#cc-rental-accessibility-strings');
  if (!product || !stringsNode || product.dataset.ccRentalAccessibility) return;
  let strings;
  try { strings = JSON.parse(stringsNode.textContent); } catch { return; }
  if (!strings.start_date || !strings.end_date || !strings.required || !strings.optional) return;
  product.dataset.ccRentalAccessibility = 'true';
  let serial = 0;
  let pending = false;
  const managedNames = new WeakMap();
  const labelIds = new WeakMap();
  function dateLabel(widget, markerId, text) {
    const marker = widget.querySelector('#' + markerId);
    const wrapper = marker?.closest('label.label_izyrent');
    const input = wrapper?.querySelector('input.izyDate[type="text"]');
    if (!input) return;
    let label = wrapper.querySelector('[data-cc-rental-date-label]');
    if (!label) {
      label = document.createElement('span');
      label.className = 'cc-rental-date-label';
      label.dataset.ccRentalDateLabel = markerId;
      label.id = 'cc-rental-date-label-' + (++serial);
      label.textContent = text;
      wrapper.insertBefore(label, wrapper.firstChild);
    }
    const existing = input.getAttribute('aria-labelledby');
    if (!input.getAttribute('aria-label') && (!existing || existing === labelIds.get(input))) {
      input.setAttribute('aria-labelledby', label.id);
      labelIds.set(input, label.id);
    }
  }
  function refresh() {
    pending = false;
    const widget = product.querySelector('#izyrent');
    if (!widget) return;
    dateLabel(widget, 'startDate', strings.start_date);
    dateLabel(widget, 'endDate', strings.end_date);
    widget.querySelectorAll('.izyAddon').forEach(addon => {
      const input = addon.querySelector('input.izyBox[type="checkbox"]');
      const title = addon.querySelector('.addonTitle')?.textContent.trim();
      if (!input || !title || input.hasAttribute('aria-labelledby')) return;
      const current = input.getAttribute('aria-label');
      if (current && current !== 'izyBox' && current !== managedNames.get(input)) return;
      const price = addon.querySelector('.addonPrice')?.textContent.trim();
      const status = addon.dataset.required === 'true' ? strings.required : strings.optional;
      const name = [title, price, status].filter(Boolean).join('. ');
      if (current !== name) input.setAttribute('aria-label', name);
      managedNames.set(input, name);
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(refresh);
  }
  new MutationObserver(schedule).observe(product, {childList:true,subtree:true});
  refresh();
})();
